import React from "react";
import "./Home.css";
import Hero from "./Hero";
import HowGoopter from "./HowGoopter";
import CommonUseCases from "components/CommonUseCases";
import SoftwareSolution from "./SoftwareSolution";
import HardwareSolution from "./HardwareSolution";
import MerchantService from "./MerchantService";
import WhatsSets from "./WhatsSets";
import WaitingFor from "components/Banner/WaitingFor";
import { ReactComponent as HeroBg1 } from "images/background/hero-section-right-triangle.svg";
import { ReactComponent as HeroBg2 } from "images/background/hero-section-left-triangle.svg";
import { ReactComponent as HeroBg3 } from "images/background/hero-section-red-triangle.svg";

const Home = ({ navOpen }) => {
  return (
    <>
      <div className={`home ${navOpen ? "navOpen" : null}`}>
        <HeroBg1 className="hero-bg1" />
        <HeroBg2 className="hero-bg2" />
        <HeroBg3 className="hero-bg3" />
        <Hero />
        <HowGoopter />
        <SoftwareSolution />
        <MerchantService />
        <HardwareSolution />
        <CommonUseCases data="useCaseData" />
        <WhatsSets />
        <WaitingFor />
      </div>
    </>
  );
};

export default Home;
